if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          inputLanguage: this.querySelector('input[name="locale_code"]'),
          inputCountry: this.querySelector('input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          select: document.querySelector('select[name="country"]'),
          selectLanguage: document.querySelector('select[name="language"]'),
          submitButton: document.getElementById('desktop-localization-wrapper-submit'),
        };

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        if (this.elements.select) {
          this.elements.select.addEventListener('change', this.onItemClick.bind(this));
        }
        if (this.elements.selectLanguage) {
          this.elements.selectLanguage.addEventListener('change', this.onLanguageChange.bind(this));
        }

        if (this.elements.submitButton) {
          this.elements.submitButton.addEventListener('click', () => {
            this.onSubmitForm();
          });
        }
      }

      onItemClick(event) {
        event.preventDefault();

        if (!event.target.classList.contains('language-selector__link--start')) {
          const form = this.querySelector('form');

          if (event.target.classList.contains('language-selector__link--country')) {
          
            const countryCode = event.target.dataset.value;
          
            let lang = 'en';
          
            if (countryCode === 'DE') lang = 'de';
            else if (countryCode === 'FR') lang = 'fr';
            else if (countryCode === 'ES') lang = 'es';
            else if (countryCode === 'IT') lang = 'it';
          
            document.querySelector('.country-selector__input').value = lang;
          }

          this.elements.input.value = event.target.dataset.value;

          if (form) form.submit();
        } else {
          if (event.target.classList.contains('country--link')) {
            const selectedCountry = event.target.dataset.value;
          
            // Met à jour l'input caché pour le pays sélectionné
            document.getElementById('HeaderCountryLanguageForm')
              .querySelector('input[name="country_code"]').value = selectedCountry;
          
            // Définition des langues par pays
            const languagesByCountry = {
              DE: [
                { code: 'de', name: 'Deutsch', flag: 'https://flagcdn.com/de.svg' },
                { code: 'en', name: 'English', flag: 'https://flagcdn.com/gb.svg' },
                { code: 'fr', name: 'Français', flag: 'https://flagcdn.com/fr.svg' },
              ],
              CN: [
                { code: 'en', name: 'English', flag: 'https://flagcdn.com/gb.svg' },
              ],
              ES: [
                { code: 'es', name: 'Español', flag: 'https://flagcdn.com/es.svg' },
                { code: 'en', name: 'English', flag: 'https://flagcdn.com/gb.svg' },
                { code: 'fr', name: 'Français', flag: 'https://flagcdn.com/fr.svg' },
              ],
              IT: [
                { code: 'it', name: 'Italiano', flag: 'https://flagcdn.com/it.svg' },
                { code: 'en', name: 'English', flag: 'https://flagcdn.com/gb.svg' },
                { code: 'fr', name: 'Français', flag: 'https://flagcdn.com/fr.svg' },
              ],
            };
          
            const justEnglishCountries = [
              'CY', 'AT', 'BE', 'BG', 'HR', 'DK', 'EE', 'FI', 'GR', 'HU', 'IE',
              'LV', 'LT', 'LU', 'MT', 'MC', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'SE', 'CZ'
            ];
          
            function getLanguagesForCountry(countryCode) {
              if (languagesByCountry[countryCode]) {
                return languagesByCountry[countryCode];
              }
              if (justEnglishCountries.includes(countryCode)) {
                return [
                  { code: 'en', name: 'English', flag: 'https://flagcdn.com/gb.svg' }
                ];
              }
              return [
                { code: 'en', name: 'English', flag: 'https://flagcdn.com/gb.svg' }
              ];
            }
          
            const allowedLanguages = getLanguagesForCountry(selectedCountry).map(lang => lang.code);
          
            // Affiche/Masque les liens existants dans le DOM
            const allLangLinks = document.querySelectorAll('.language-selector__link.language--link');

            allLangLinks.forEach(link => {
              const langCode = link.dataset.value;

              if (allowedLanguages.length == 1 && allowedLanguages.includes(langCode)) {
                link.style.display = 'flex';
                const value = link.innerHTML;
                const button = link.closest('.disclosure__list-wrapper').querySelector('.language-selector__button-content');
                if (button) {
                  button.innerHTML = value;
                }
          
                const hiddenInput = document.querySelector('input[name="country_code"]');
                if (hiddenInput && link.dataset.value) {
                  hiddenInput.value = link.dataset.value;
                }
              }
          
              if (allowedLanguages.includes(langCode)) {
                link.style.display = 'flex';
              } else {
                link.style.display = 'none';
              }
            });
          } else if (event.target.classList.contains('language--link')) {
            document.getElementById('HeaderCountryLanguageForm').querySelector('input[name="locale_code"]').value = event.target.dataset.value;
          }
        }
      }

      onSubmitForm() {
        const form = document.getElementById('HeaderCountryLanguageForm');
        if (form) form.submit();
      }
    }
  );
}
